import {deviceParams} from "./constants.js";

// devices on older firmware may have an old RC module installed, so RC temperatures are only shown from this version
const requiredRCFirmwareVersion = 7000

/** Returns the RC water temperature telemetry keys to show for a device, based on parameter 851 "RC Module Installed"
 *  Requires firmware version >= 7000
 *  missing / 0 = No -> none
 *  1 = Cooling only, 2 = Heating only, 3 = Cooling and heating, common water supply -> 1082 + 1083
 *  4 = Cooling and heating, separate water supply -> 1084 + 1085 + 1086 + 1087
 * @param device
 * @returns {number[]} empty if RC temperatures should not be shown */
export function getRCTemperatureKeys(device) {
    const firmwareVersion = parseInt(device?.device_twin?.reported?.applicationVersion?.replace(/\./g, ''))
    if (!(firmwareVersion >= requiredRCFirmwareVersion)) return []

    switch (device?.device_twin?.reported?.parameters?.[deviceParams.rc_module_installed]) {
        case "1":
        case "2":
        case "3":
            return [deviceParams.temperature_water_supply, deviceParams.temperature_water_return]
        case "4":
            return [deviceParams.temperature_water_supply_heating, deviceParams.temperature_water_return_heating,
                deviceParams.temperature_water_supply_cooling, deviceParams.temperature_water_return_cooling]
        default:
            return []
    }
}
